import Vue from 'vue'
import i18next from 'i18next'
import VueI18Next from '@panter/vue-i18next'
import enTranslation from './en.json'

Vue.use(VueI18Next)

i18next.init({
  lng: 'en',
  fallbackLng: {
    default: ['en'],
  },
  resources: {
    en: {
      translation: enTranslation,
    },
  },
})
export default new VueI18Next(i18next)
